const messages = {
  bankMetaDescription: 'bankDetail.metaDescription',
  bankFaqHeadline: 'bankProductPage.faqHeadline',
  bankFaqQuestion1: 'bankProductPage.faq.question1',
  bankFaqAnswer1: 'bankProductPage.faq.answer1',
  bankFaqAnswer1Link: 'bankProductPage.faq.answer1.link',
  bankFaqQuestion2: 'bankProductPage.faq.question2',
  bankFaqAnswer2: 'bankProductPage.faq.answer2',
  bankFaqAnswer2Link: 'bankProductPage.faq.answer2.link',
  bankFaqQuestion3: 'bankProductPage.faq.question3',
  bankFaqAnswer3: 'bankProductPage.faq.answer3',
  bankFaqQuestion4: 'bankProductPage.faq.question4',
  bankFaqAnswer4: 'bankProductPage.faq.answer4',
  bankFaqQuestion5: 'bankProductPage.faq.question5',
  bankFaqAnswer5: 'bankProductPage.faq.answer5',
  bankFaqQuestion6: 'bankProductPage.faq.question6',
  bankFaqAnswer6: 'bankProductPage.faq.answer6',
  bankFaqAnswer6Link: 'bankProductPage.faq.answer6.link',
  bankFaqQuestion7: 'bankProductPage.faq.question7',
  bankFaqAnswer7: 'bankProductPage.faq.answer7',
  bankFaqAnswer7Link: 'bankProductPage.faq.answer7.link',
  bankFaqQuestion8: 'bankProductPage.faq.question8',
  bankFaqAnswer8: 'bankProductPage.faq.answer8',
  bankFaqAnswer8Link: 'bankProductPage.faq.answer8.link',
  affiliateHeroBannerTitle: 'bank.product.affiliate.banners.hero.title',
  affiliateHeroBannerTitleForOn: 'bank.product.affiliate.banners.hero.title.on',
  affiliateHeroBannerTitleForNa: 'bank.product.affiliate.banners.hero.title.na',
  affiliateHeroBannerCountryOriginSubtitle: 'bank.product.affiliate.banners.hero.subtitle',
  affiliateHeroBannerListItemNoCosts: 'bank.product.affiliate.banners.hero.listItem.noCosts',
  affiliateHeroBannerListItemFinanztestBestenliste:
    'bank.product.affiliate.banners.hero.listItem.finanztestBestenliste',
  affiliateHeroBannerListItemSaveAlreadyFrom:
    'bank.product.affiliate.banners.hero.listItem.saveAlreadyFrom',
  affiliateHeroBannerListItemCompoundingInterest:
    'bank.product.affiliate.banners.hero.listItem.compoundingInterest',
  affiliateHeroBannerListItemCompoundingInterestWeekly:
    'bank.product.affiliate.banners.hero.listItem.compoundingInterest.period.weekly',
  affiliateHeroBannerListItemCompoundingInterestMonthly:
    'bank.product.affiliate.banners.hero.listItem.compoundingInterest.period.monthly',
  affiliateHeroBannerListItemCompoundingInterestQuarterly:
    'bank.product.affiliate.banners.hero.listItem.compoundingInterest.period.quarterly',
  affiliateHeroBannerListItemCompoundingInterestYearly:
    'bank.product.affiliate.banners.hero.listItem.compoundingInterest.period.yearly',
  affiliateHeroBannerListItemInterestRatePaidOut:
    'bank.product.affiliate.banners.hero.listItem.interestRatePaidOut',
  affiliateHeroBannerListItemSavingsPlanPossible:
    'bank.product.affiliate.banners.hero.listItem.savingsPlanPossible',
  affiliateHeroBannerListItemEnjoyFixesAndHighRates:
    'bank.product.affiliate.banners.hero.listItem.enjoyFixesAndHighRates',
  affiliateCTABannerText: 'bank.product.affiliate.banners.cta.text',
  affiliateCTAButtonText: 'bank.product.affiliate.banners.cta.button',
  affiliateStepsFirstStepIconText: 'bank.product.affiliate.steps.firstStep.iconText',
  affiliateStepsFirstStepTitle: 'bank.product.affiliate.steps.firstStep.title',
  affiliateStepsFirstStepDescription: 'bank.product.affiliate.steps.firstStep.description',
  affiliateStepsSecondStepIconText: 'bank.product.affiliate.steps.secondStep.iconText',
  affiliateStepsSecondStepTitle: 'bank.product.affiliate.steps.secondStep.title',
  affiliateStepsSecondStepDescription: 'bank.product.affiliate.steps.secondStep.description',
  affiliateStepsThirdStepIconText: 'bank.product.affiliate.steps.thirdStep.iconText',
  affiliateStepsThirdStepTitle: 'bank.product.affiliate.steps.thirdStep.title',
  affiliateStepsThirdStepDescription: 'bank.product.affiliate.steps.thirdStep.description',
  affiliateWebBannerSubTitle: 'bank.product.affiliate.web.banner.subtitle',
  affiliateWebBannerOvernightOrNoticeTitle: 'bank.product.affiliate.web.banner.on.title',
};

export default messages;
